import React from "react";

import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import useStyles from "@hooks/useStyles";
import useConstants from "@hooks/useConstants";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const { BRAND_NAME } = process.env;

const ProPricing = () => {
	const classes = useStyles("Pro");

	const { h2, head_1, subhead_1, head_2, subhead_2, head_3, subhead_3 } =
		useConstants("ProPricingViewModel");

	return (
		<Box
			component="section"
			className={classes.hiwWrapper}
			display={"flex"}
			alignItems={"center"}
			justifyContent={"center"}
		>
			<Container maxWidth={false} className={classes.proContainer}>
				<h2 className={classes.joinH2}>{h2}</h2>

				<Grid container spacing={8}>
					<Grid item xs={12} sm={12} md={4}>
						<div className={classes.stepBox}>
							<CheckCircleIcon className={classes.hiwIcon} />

							<h3 className={classes.joinH3}>{head_1}</h3>

							<p className={classes.joinBodyText}>{subhead_1}</p>
						</div>
					</Grid>

					<Grid item xs={12} sm={12} md={4}>
						<div className={classes.stepBox}>
							<CheckCircleIcon className={classes.hiwIcon} />

							<h3 className={classes.joinH3}>{head_2}</h3>

							<p className={classes.joinBodyText}>{subhead_2}</p>
						</div>
					</Grid>

					<Grid item xs={12} sm={12} md={4}>
						<div className={classes.stepBox}>
							<CheckCircleIcon className={classes.hiwIcon} />

							<h3 className={classes.joinH3}>{head_3}</h3>

							<p className={classes.joinBodyText}>{subhead_3}</p>
						</div>
					</Grid>
				</Grid>
			</Container>
		</Box>
	);
};
ProPricing.propTypes = {};
export default ProPricing;
